<template>
    <div>
        <!-- password -->
        <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }"
            :class="[{ 'is-loading': is_loading }, { 'is-error': is_error }]" :need_error="true">
            
            <div class="label-text-box">
                <div class="small-label">Password</div>
                <a href="#" v-if="!edit_password" @click="handleChangeEdit('edit_password', $event)">Change password</a>
                <router-link v-if="!edit_password" to="/reset-password"  @click="handleChangeEdit('edit_password', $event)">Reset</router-link>
            </div>


            <div v-if="edit_password" class="password-input-box">
                <Field type="password" k="current_password" placeholder="Current password"
                    :error_msg="errors.current_password" :is_success="success.current_password" @update="update"
                    :handle_err="is_error" :handle_success="value_is_err.current_password" />

                <div class="err-msg-box-se" v-if="is_error && error_msg">
                    <p v-html="error_msg" class="error-password-msg"></p>
                    <i>
                        <SvgIcon name="alert" class="icon-left" />
                    </i>
                </div>

                <Field type="password" k="new_password" placeholder="New password" :error_msg="errors.new_password"
                    :is_success="success.new_password" @update="update" :no_show_err_msg="true"
                    :handle_success="value_is_err.new_password" />
                <Field type="password" k="confirm_new_password" placeholder="Repeat new password"
                    :error_msg="errors.confirm_new_password" :is_success="success.confirm_new_password" @update="update"
                    :no_show_err_msg="true" :handle_success="value_is_err.confirm_new_password" />


                <CheckFieldText :check_password_text="check_password_text" :is_error="is_error" />

                <div class="btn-box">
                    <div class="forgot-box">
                        Forgot password?&nbsp;
                        <router-link to="/reset-password">Reset</router-link>
                    </div>
                    <el-button
                        @click="handleChangeEdit('edit_password', $event)">Cancel</el-button>
                    <Button size="32" color="dark-blue" type="submit" :is_disabled="!can_save" :border_r="6">Save</Button>
                </div>
            </div>
        </Form>


        <div class="footer-box">
            <el-button  class="btn-padding" @click="Logout">Log out</el-button >
            <div class="btn-box">
                <a v-if="$store.state.user_data.merchant_account !== null" class="leave" @click="openEditLeave('leave')">Leave team</a>
                <a class="delete-account" @click="openEditLeave('del')">Delete account</a>
            </div>
        </div>

        <!-- leave & del dialog -->
        <el-dialog :title="dialogValue.title" width="400" v-model="handleDialogOpen"
            @close="handleDialogOpen = false; handleOwnerLeaveListIndex = null" class="handle-dialog">
            <p>{{ dialogValue.content }}</p>
            <el-select v-model="handleOwnerLeaveListIndex" v-if="handleDialog === 3" :reserve-keyword="false">
                <el-option v-for="item in handleOwnerLeaveList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <div class="btn-row">
                <el-button @click="handleDialogOpen = false" type="text">Cancel</el-button>
                <el-button type="danger" :disabled="handleDialog === 3 ? !handleOwnerLeaveListIndex : false"
                    @click="handleConfirmLeave()">{{ dialogValue.btn }}</el-button>
            </div>
        </el-dialog>
        <!-- identity dialog -->
        <IdenityDialog ref="idDia" @remove-user="refrashPage()" :handleDialog="handleDialog"/>
    </div>
</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import AccountEmail from '@/components/settings/YourAccount/AccountEmail.vue';
import Loading from '@/components/ui/Loading.vue';
import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);
import Scrollbar from '@/components/ui/Scrollbar.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import CheckFieldText from '@/components/ui/CheckFieldText.vue';
import { ElSelect, ElOption, ElButton, ElDialog } from 'element-plus';
import IdenityDialog from '@/components/settings/IdenityDialog.vue';

export default {
    name: 'Security',

    components: {
        Field,
        Form,
        Button,
        Dropdown,
        AccountEmail,
        Loading,
        Scrollbar,
        SvgIcon,
        CheckFieldText,
        ElButton,
        ElDialog,
        IdenityDialog,
        ElSelect,
        ElOption,
    },

    props: {
    },

    emits: [
        'refrash'
    ],

    data() {
        return {
            is_loading: false,
            edit_email: false,
            edit_password: false,
            schema: yup.object().shape({
                //current_password: yup.string().required('The password can’t leave as blank'),
                new_password: yup.string()
                    .password()
                    .notOneOf(
                        [yup.ref('password'), null],
                        'New password must be different from the old password'
                    )
                    .minNumbers(1, 'Must have a number and special character')
                    .minSymbols(1, 'Must have a number and special character')
                    .minUppercase(1, 'Must contain at least 1 uppercase letter')
                    .min(14, 'Must be at least 14 characters')
                    .required('The password can’t leave as blank'),

                confirm_new_password: yup.string()
                    .oneOf(
                        [yup.ref('new_password'), null],
                        'Passwords must match'
                    )
                    .password()
                    .minNumbers(1, 'Must have a number and special character')
                    .minSymbols(1, 'Must have a number and special character')
                    .minUppercase(1, 'Must contain at least 1 uppercase letter')
                    .min(14, 'Must be at least 14 characters')
                    .required('The repeat password can’t leave as blank'),
            }),
            values: {
                current_password: '',
                new_password: '',
                confirm_new_password: '',
            },
            value_is_err: {
                current_password: true,
                new_password: true,
                confirm_new_password: true,
            },
            is_error: false,
            error_msg: '',
            //handleLeaveData
            is_admin: true,
            member_parms: {
                current_page: 1,
                per_page: 100,
            },
            members_select: [],
            //9625 new
            handleDialogOpen: false,
            handleDialog: 2,
            handleNowUser: null,
            handleOwnerLeaveList: [],
            handleOwnerLeaveListIndex: null,
            isDelete: false,

        }
    },

    computed: {
        check_password_text() {
            return [
                {
                    text: 'Must be at least 14 characters',
                    is_correct: this.values['new_password'].length >= 14
                },
                {
                    text: 'Must have a number and special character',
                    is_correct: this.isValidPassword(this.values.new_password)//!this.value_is_err['new_password']//values.new_password
                },
                {
                    text: 'Must contain at least 1 uppercase letter',
                    is_correct: this.isValidUppercasePassword(this.values.new_password)//!this.value_is_err['new_password']//values.new_password
                },
                {
                    text: 'Password should not be same as current',
                    is_correct: this.values['current_password'] && this.values['new_password'] && this.values['current_password'] !== this.values['new_password']
                },
                {
                    text: 'Password match',
                    is_correct: this.values['new_password'] && this.values['new_password'] == this.values['confirm_new_password']
                },
            ]
        },

        can_save() {
            // this.btn_refrash += 1;
            return this.check_password_text.every(item => item.is_correct);
        },
        dialogValue() {
            let mer_name = this.$store.state.user_data?.merchant_account?.merchant_display_name;
            if (this.handleDialog == 1) {
                return {
                    title: 'Are you sure you want to delete your account?',
                    content: `All data and information associated with your account will be permanently deleted.`,
                    btn: 'Confirm',
                }
            }
            else if (this.handleDialog == 2) {
                return {
                    title: 'Leave this team',
                    content: `Leaving this team will revoke your access to the dashboard and data associated with this workspace. You’ll still be able to access any other workspaces with your current login, if applicable.`,
                    btn: 'Confirm',
                }
            }else if (this.handleDialog == 3) {
                return {
                    title: 'Leave team and transfer ownership',
                    content: `To leave the ${mer_name} portal workspace, you’ll need to transfer ownership.  Once ownership is reassigned, you will then be able to leave the workspace.`,
                    btn: 'Transfer ownership',
                }
            }else{
                return{
                    title: 'Delete account',
                    content: `All data and information associated with your account will be permanently deleted.`,
                    btn: 'Confirm',
                }
            }
        },
    },

    watch: {

    },

    methods: {
        isValidPassword(password) {
            const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?]).+$/;
            return regex.test(password);
        },
        isValidUppercasePassword(password) {
            const regex = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
            return regex.test(password);
        },
        start() {
            if (this.$store.state.user_data && this.$store.state.user_data.roles[0]) {
                if (this.$store.state.user_data.roles[0].name == 'admin') {
                    this.is_admin = true;
                } else {
                    this.is_admin = false;
                }
                this.callUsetList();
            }
        },

        callUsetList(){
            this.is_loading = true;
            this.$ajax('/settings/get-team-user-list', {
                method: 'get',
                withCredentials: true,
            }).then(res=>{
                this.handleOwnerLeaveList = res.data.data.filter(e => (e.id !== this.$store.state.user_data.id) && e.last_api_call_at);
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            })
        },

        update(obj) {

            if (obj.val) {
                this.error_msg = '';
                this.is_error = false;
            }

            Object.keys(this.values).forEach(key => {
                if (key === obj.key) {
                    this.values[key] = obj.val;
                    if (obj.key !== 'current_password') {
                        this.validate(key)
                    } else {
                        this.value_is_err[key] = obj.val ? false : true;
                    }
                }
            });

        },

        //Listening to the input box being typed.
        validate(field) {
            this.value_is_err[field]=this.isValidPassword(this.values['current_password']);
        },

        handleChangeEdit(field, $event) {
            $event.preventDefault(); // 阻止默认链接行为
            //now have edit_email || edit_password
            if (this[field]) {
                this[field] = false;
                this.$emit('refrash');
            } else {
                this[field] = true;
                
            }
        },

        handleChangeEmail(val) {
            this.handleChangeEdit('edit_email', val);
        },

        //submit password change
        submit(val) {
            if (this.can_save) {
                if (!val) {
                    this.is_error = true;
                } else {
                    this.is_error = false;
                    this.error_msg = '';
                    this.is_loading = true;
                    this.$ajax('/settings/update-login-user-password', {
                        method: 'post',
                        data: this.values,
                    }).then(res => {
                        this.is_loading = false;
                        this.edit_password = false;
                        this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> Password updated');
                    }).catch(err => {
                        this.is_loading = false;

                        if (err && err.response && err.response.data.data) {
                            this.is_error = true;
                            this.error_msg = err.response.data.data.message;
                        }
                    });
                }
            } else {
                this.is_error = true;
            }
        },

        checkAnotherAdmin() {
        },

        async openEditLeave(val) {
            this.isDelete = false;
            let role_type = this.$store.state.user_data.permission_list.role_type;
            if(val==='del'){
                this.handleDialog = 1;
                this.isDelete = true;
            }else if(role_type === 100 || role_type===200 ){
                this.handleDialog = 3;
            }else{
                this.handleDialog = 2;   
            }
            this.handleDialogOpen = true;

        },

        handleConfirmLeave() {
            this.handleNowUser = this.handleOwnerLeaveList.filter(e => e.id == this.handleOwnerLeaveListIndex)[0];
            let role_type = this.$store.state.user_data.permission_list.role_type;
            if(this.handleDialog == 1){
                if(role_type === 100 || role_type ===200 ){
                    this.handleDialog = 3;
                }else{
                    this.$refs.idDia.delUser();
                }
                
            }else if(this.handleDialog == 2){
                this.removeUser();
            }else{
                if(this.isDelete){
                    this.$refs.idDia.open(1,this.handleNowUser,'del');
                }else{
                    this.$refs.idDia.open(1,this.handleNowUser);
                }   
            }
        },

        removeUser(){
            this.is_loading = true;
            let formData = new FormData();
            formData.append('remove_portal_user_id', this.$store.state.user_data.id);

            this.$ajax.post(`/settings/remove-merchant-user`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                
                window.location.href = '/landing';

            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        refrashPage(){
            window.location.href = '/landing';
        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify({
                text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
                </svg>
                ${mes}`,
                group: 'white',
                type: 'warn',
            });
        },

        callMemberList() {
            const params = Object.entries(this.member_parms).map(([key, val]) => `${key}=${val}`).join('&');
            return new Promise((reslove) => {
                this.$ajax.get(`/settings/portal-user-list?` + params + `&t=${new Date().getTime()}`).then(res => {
                    if (this.member_parms.current_page === 1)
                        this.members_select = res.data.data.data;
                    else
                        res.data.data.data.forEach(p => {
                            this.data_products.push(p);
                        });

                    reslove({ last_page: Number(res.data.last_page) })
                });
            });
        },

        Logout() {
            this.$router.replace('/logout');
        },


    },

    mounted() {
        this.start();
    },
}
</script>
<style lang="scss">
.password-input-box {
    background: var(--light-neutral);
    padding: 13px;
    margin-top: 24px;

    .btn-box {
        .forgot-box{
            flex:1;
        }

        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        gap:8px;
    }
}

.label-text-box {
    margin-top: 16px;
    display: flex;
    align-items: center;

    .small-label {
        margin: 0 !important;
        padding: 0 !important;
    }

    a {
        font-size: 12px;
        margin-left: 10px;
    }
}

.check-text-box {
    margin: 0 0 20px 0;
    font-family: var(--font);
    font-size: 12px;
    font-weight: 500;

    .check-text {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: var(--black-50);

        i {
            width: 14px;
            height: 14px;
            margin-left: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        svg {
            width: 10.5px;
            height: 10.5px;
            fill: var(--black-50);
        }

        &.check-text-green {
            color: var(--green);

            svg {
                fill: var(--green);
            }
        }

        &.check-text-red {
            color: var(--alert);

            svg {
                fill: var(--alert);
            }
        }
    }
}

.ui-input {
    margin: 10px 0;

    &:first-child {
        margin-top: 0;
    }
}



.forgot-box {
    width: 100%;
    display: flex;
    font-family: var(--font);
    color: var(--black-90);
    font-weight: 500;
    font-size: 12px;
    align-items: center;
}

.footer-box {
    border-top: solid 1px var(--black-40);
    margin-top: 20px;
    padding: 18px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
        color: var(--dark-red);
        font-weight: 500;
        font-family: var(--font-med);
        font-size: 12px;
        display: block;
        cursor: pointer;
        padding: 8px 24px;
    }

}

.error-password-msg {
    margin: 4px;
    font-size: 12px;
    color: var(--alert);
}

.err-msg-box-se {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: -10px;

    i {
        width: 14px;
        height: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
    }

    svg {
        width: 10.5px;
        height: 10.5px;
        fill: var(--alert);
    }

}

</style>

